module.exports = __webpack_public_path__ + "static/media/video-section-image.699b46a6.jpg";